import React, {Component} from 'react';
import {connect} from 'react-redux';
import RuleItem from '../molecules/rule-item';
import RemoveRuleItem from '../atoms/remove-rule-item';
import {isAnyPlayerAbsentInRuleItem} from '../../helpers';

class RuleItems extends Component {
    render() {
        const {projectionBoostRule, players} = this.props;
        const items = projectionBoostRule.getItems();

        return (
            <div className="advanced-tags">
                {Object.values(items).map((item) => {
                    return isAnyPlayerAbsentInRuleItem(item, players) ? null : (
                        <RuleItem key={item.getId()} itemId={item.getId()}>
                            <RemoveRuleItem itemId={item.getId()} />
                        </RuleItem>
                    );
                })}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        projectionBoostRule,
        playersData: {players},
    } = state;

    return {
        projectionBoostRule,
        players,
    };
}

export default connect(mapStatesToProps)(RuleItems);
